<template>
  <div class="xz-BgColor-All">
    <div v-for="(item, index) in courseList" :key="index" class="m-t-05">
      <p class="f-s-10 gray-3 margin15-bottom">
        {{ item.title }}
        <span class="f-l-r lookMore" @click="lookMore(item)">查看更多 ></span>
      </p>
      <ul>
        <li
          @click="selectCourse(index, idx)"
          v-for="(itm, idx) in item.list"
          :key="idx"
          class="listBox padding15 margin15-bottom relative"
        >
          <div class="row">
            <p>
              <span
                class="ilbk ft10 lineHe10 white text-center flagBox m-r-8"
              >
                {{ itm.itname }}
              </span>
              <span class="gary-2 ft16" style="text-indent: 0.6rem">{{
                itm.courseTitle
              }}</span>
            </p>
          </div>
          <p class="f-s-65 gray-8 margin5-top">
            {{ itm.startTime }} 至 {{ itm.endTime }} | {{ itm.ccount }}课时
          </p>
          <div class="row cen-between margin15-top">
            <div class="row">
              <span
                class="text-center tBox"
                v-for="(val, i) in itm.tlist"
                :key="i"
              >
                <span class="userBox ilbk">
                  <img :src="val.turl" alt="" />
                </span>
                <p class="ft10 gray-8">{{ val.tname }}</p>
              </span>
            </div>
            <span class="text-right ft22 gray-8" v-if="itm.ifSoldOut">
              已售罄
            </span>
            <span v-else class="orangered text-right">
              <p class="ft12 gray-8" v-if="itm.acttypeid == 1">
                <del>¥{{ itm.courseOriginal }}</del>
              </p>
              <span class="ft12">¥</span>
              <span class="ft22">{{ itm.coursePrice }}</span>
              <p class="ft12 gray-8" v-if="itm.acttypeid != 1">
                {{ itm.courseXnum }}人已购
              </p>
              <p class="ft12 gray-8" v-if="itm.mmdd">
                <span>截止时间：</span>
                <span class="col_E3">{{ itm.mmdd }}</span>
              </p>
            </span>
          </div>
          <span class="absolute prompt" v-if="itm.acttypeid == 1">
            <img src="../../assets/imgs/prompt.png" alt="" />
          </span>
        </li>
      </ul>
      <div class="row cen-center text-center d-s-n">
        <span
          @click="moreCourse(index)"
          v-if="
            (freeCoursePage != 0 && index == 0) ||
            (PaidCoursePage != 0 && index == 1)
          "
          class="ilbk moreBox orangered ft12"
          >查看更多</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFreeCourseList,
  getPaidCourseList,
} from "../../model/home/homeServe";
export default {
  name: "list",
  data() {
    return {
      courseList: [],
      freeCoursePage: 1,
      PaidCoursePage: 1,
    };
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    dataList(val) {
      this.courseList = val;
    },
  },
  methods: {
    lookMore(item) {
      if (item.title == "免费公开课") {
        this.$router.push({
          path: "/classification",
          query: {
            type: false,
          },
        });
      } else {
        this.$router.push({
          path: "/classification",
          query: {
            type: true,
          },
        });
        this.$router.push("classification", { type: true });
      }
    },
    selectCourse(index, idx) {
      let parme = this.courseList[index].list[idx];
      this.$router.push({
        path: "/details",
        query: {
          cid: parme.cid,
        },
      });
    },
    moreCourse(index) {
      if (index === 0) {
        if (this.freeCoursePage) {
          getFreeCourseList(this.freeCoursePage).then((res) => {
            this.freeCoursePage = res.data.pageNo;
            this.courseList[index].list = this.courseList[index].list.concat(
              res.data.clist
            );
          });
        }
      }
      if (index === 1) {
        if (this.PaidCoursePage) {
          getPaidCourseList(this.PaidCoursePage).then((res) => {
            this.PaidCoursePage = res.data.pageNo;
            this.courseList[index].list = this.courseList[index].list.concat(
              res.data.clist
            );
          });
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.tBox {
  margin-right: 12/20rem;
}
.listBox {
  background: rgba(255, 255, 255, 1);

  box-shadow: 0px 0px 8px 1px rgba(0, 6, 22, 0.04);
  border-radius: 5/20rem;
  box-sizing: border-box;
  .flagBox {
    top: 0.15rem;
    padding: 4/20rem 0.2rem;
    background: rgba(87, 89, 96, 1);
    border-radius: 2px;
  }
  .userBox {
    width: 33/20rem;
    height: 33/20rem;
    border-radius: 100%;
    img {
      border-radius: 100%;
    }
  }
}
.col_E3 {
  color: #e31111;
}
.prompt {
  right: 0;
  top: -0.2rem;
  width: 48/20rem;
  height: 15/20rem;
}
.padding30_left {
  padding-left: 1.6rem;
}
.moreBox {
  width: 116/20rem;
  height: 33/20rem;
  line-height: 33/20rem;
  border: 1px solid rgba(241, 132, 69, 1);
  border-radius: 5/20rem;
}
</style>
